import React, { createContext, ReactNode, useContext, useState } from "react";

interface BadgeContextType {
    newClaimsBadgeValue: number;
    setNewClaimsBadgeValue: React.Dispatch<React.SetStateAction<number>>;
}

const BadgeContext = createContext<BadgeContextType | undefined>(undefined);

export const useBadge = () => {
    const context = useContext(BadgeContext);
    if (!context) {
        throw new Error('useBadge must be used within a BadgeProvider');
    }
    return context;
};

export const BadgeProvider = ({ children }: { children: ReactNode }) => {
    const [newClaimsBadgeValue, setNewClaimsBadgeValue] = useState(0);

    return (
        <BadgeContext.Provider value={{ newClaimsBadgeValue, setNewClaimsBadgeValue }}>
            {children}
        </BadgeContext.Provider>
    );
};